export const MembersList = [
    'person_read_id',
    'person_read_title',
    'person_read_name',
    'person_read_pat_last_name',
    'person_read_mat_last_name',
    'person_read_specialty',
    'person_read_date_of_death',
    'specialty_read_name',
    'person_read_residence',
    'person_read_email',
    'person_read_membership',
    'membership_read_id',
    'membership_read_type',
    'membership_read_annuity_payments',
    'annuity_payment_read',
    'membership_read_ihs_member_number',
    'membership_read_has_debts',
    'membership_read_has_ihs_debts',
    'membership_read_unwanted_ihs_years',
    'unwanted_ihs_year_read',
    'person_read_photo',
    'app_file_read'
];


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/utils/PeopleSGroups.js